import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { LineChart } from "../charts/LineChart";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_aid_fig_CRS";
import { datasets } from "../data/data_finance_aid_fig_CRS_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { io } from "../prelude";
export * from "../data/data_finance_aid_fig_CRS";
const Type = io.keyof({
    FTS: null,
    CRS: null
});
const typeLookup = {
    FTS: defineMessage({
        id: "fig.finance.aid.CRS.FTS",
        defaultMessage: "FTS"
    }),
    CRS: defineMessage({
        id: "fig.finance.aid.CRS.CRS",
        defaultMessage: "CRS"
    })
};
export const Data = mkGemDataDecoder([
    "value",
    "ind_id",
    "year"
], {
    type: Type
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenMDown = !useMedia(breakpoints.m);
    const entityData = React.useMemo(()=>data.map((x)=>({
                ...x,
                type: intl.formatMessage(typeLookup[x.type])
            })), [
        intl,
        data
    ]);
    return <LineChart tLabel={(s)=>s} height={screenMDown ? M.chartHeight.s : M.chartHeight.m} x="year" yTicks={[
        0,
        0.2,
        0.4,
        0.6,
        0.8,
        1.0,
        1.2,
        1.4,
        1.6,
        1.8
    ]} timeParse="%Y" timeFormat="%Y" numberFormat=".2f" category="datum.type" yAxisLabel={intl.formatMessage(defineMessage({
        id: "USD billion",
        defaultMessage: "USD billion"
    }))} tooltipFormatX={(x)=>x.type} colorLegend values={entityData} showTooltip yNice={0}/>;
};
export default withFigureIO({
    url: new URL("../data/data_finance_aid_fig_CRS.json", import.meta.url).href,
    csv: new URL("../data/data_finance_aid_fig_CRS.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_aid_fig_CRS.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    size: "main",
    datasets
});
